// Texty ikon hlavičky a otváracích hodín — slovenské dvojče locale/cs/headerTools.js.
export default {
  dayShort: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
  closed: 'Zatvorené',
  login: 'Prihlásenie',
  account: 'Môj účet',
  wishlist: 'Obľúbené',
  call: (phone) => 'Zavolať ' + phone,
  supportUntil: (to) => 'Online do ' + to,
  supportBack: (when, from) => 'Späť ' + when + ' o ' + from,
  supportOnlineLong: (to) => 'Práve online, odpovedáme do\u00A0' + to,
  supportOfflineLong: (when, from) => 'Mimo pracovného času, ozveme sa ' + when + ' od\u00A0' + from,
  today: 'dnes',
  tomorrow: 'zajtra',
  onDay: ['v\u00A0nedeľu', 'v\u00A0pondelok', 'v\u00A0utorok', 'v\u00A0stredu', 'vo\u00A0štvrtok', 'v\u00A0piatok', 'v\u00A0sobotu'],
  supportClosed: '–',
  mailLead: 'Alebo nám napíšte e-mail',
  mailLeadOnly: 'Napíšte nám e-mail',
  copy: 'Kopírovať',
  copied: 'Skopírované',
};
